// @flow
import { ACTIONS_NAMESPACE as CB_ACTIONS_NAMESPACE } from '../constants';

export const ACTIONS_NAMESPACE = `${CB_ACTIONS_NAMESPACE}/SIDE_PANEL`;

export const MOUNT_POINT = 'sidePanel';

export const OPEN = `${ACTIONS_NAMESPACE}/OPEN`;
export const CLOSE_NAMESPACE = `${ACTIONS_NAMESPACE}/CLOSE`;
export const CLOSE_BY_KEY = `${CLOSE_NAMESPACE}/BY_KEY`;
export const CLOSE_TOPMOST = `${CLOSE_NAMESPACE}E/TOPMOST`;
export const CLOSE_ALL = `${CLOSE_NAMESPACE}/ALL`;
export const SET_SENSITIVITY = `${ACTIONS_NAMESPACE}/SENSITIVITY`;
export const SET_TITLE = `${ACTIONS_NAMESPACE}/SET_TITLE`;

export const SIDE_PANEL_CONFIRMATION_CATEGORY = 'SP';
